<template>
  <v-card elevation="6" class="patrimonio-card rounded-xl pa-5 fill-height">
    <div class="patrimonio-content">
      <div>
        <div class="white--text dashboard-label">Patrimonio total</div>
        <div class="patrimonio-amount">{{ formatMonto(total) }}</div>
        <div class="white--text patrimonio-subtitle"></div>
        <div class="patrimonio-meta mt-5">
          <span class="patrimonio-products">
            <v-icon x-small color="#d9f48f" class="mr-1">mdi-arrow-right-top</v-icon>
            {{ activeProductsCount }} productos activos
          </span>
        </div>
      </div>
      <div class="patrimonio-icon-wrap">
        <div class="patrimonio-icon-ring">
          <v-icon color="white" size="42">mdi-badge-account-horizontal</v-icon>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import conv from "@/services/conversores";

export default {
  name: "PatrimonyCard",
  props: {
    total: {
      type: Number,
      default: 0
    },
    productos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    activeProductsCount() {
      return this.productos.filter((product) => product.status).length;
    }
  },
  methods: {
    formatMonto(value) {
      return conv.formatMonto(value || 0, true);
    }
  }
};
</script>

<style scoped>
.patrimonio-card {
  height: 100%;
  min-height: 180px;
  background-image: linear-gradient(135deg, #006f70 0%, #068d91 48%, #00545a 100%);
  box-shadow: 0 12px 24px rgba(20, 52, 57, 0.28) !important;
  overflow: hidden;
  position: relative;
}

.patrimonio-card::before {
  background: radial-gradient(circle, rgba(36, 202, 212, 0.42) 0%, rgba(36, 202, 212, 0) 68%);
  content: "";
  height: 220px;
  position: absolute;
  right: -70px;
  top: -78px;
  width: 220px;
}

.patrimonio-card::after {
  background: linear-gradient(125deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 42%);
  content: "";
  height: 240px;
  left: 140px;
  position: absolute;
  top: -50px;
  transform: skewX(-18deg);
  width: 180px;
}

.patrimonio-content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.dashboard-label {
  font-size: 0.98rem;
  font-weight: 600;
}

.patrimonio-amount {
  color: white;
  font-size: 2.75rem;
  font-weight: 800;
  letter-spacing: -1px;
  line-height: 1.18;
}

.patrimonio-subtitle {
  font-size: 1rem;
  font-weight: 500;
}

.patrimonio-meta {
  align-items: center;
  color: white;
  display: flex;
  gap: 12px;
}

.patrimonio-products {
  align-items: center;
  background: rgba(36, 202, 212, 0.25);
  border-radius: 9px;
  display: inline-flex;
  font-weight: 800;
  padding: 7px 12px;
}

.patrimonio-icon-wrap {
  align-items: center;
  background: rgba(36, 202, 212, 0.18);
  border-radius: 50%;
  display: flex;
  flex: 0 0 auto;
  height: 96px;
  justify-content: center;
  width: 96px;
}

.patrimonio-icon-ring {
  align-items: center;
  background: rgba(36, 202, 212, 0.6);
  border-radius: 50%;
  display: flex;
  height: 68px;
  justify-content: center;
  width: 68px;
}

@media (max-width: 599px) {
  .patrimonio-content {
    align-items: flex-start;
  }

  .patrimonio-amount {
    font-size: 2rem;
    overflow-wrap: anywhere;
  }

  .patrimonio-icon-wrap {
    height: 70px;
    width: 70px;
  }

  .patrimonio-icon-ring {
    height: 52px;
    width: 52px;
  }
}
</style>
